import { PatientDashboard } from "../pages/dashboard/dashboard";
import { AppLogin } from "../pages/auth/login";
import { PatientDemographics } from "../pages/demographics/demographics";
import { PatientLetters } from "../pages/patient_letters/patientLetters";
import { LabResults } from "../pages/lab_results/labResults";
import Trackers from "../pages/trackers";
import Referrals from "../pages/referrals/referrals";
import Campaigns from "../pages/campaigns/campaigns";
import CarePlan from "../pages/care_plan/carePlan";
import Telemedicines from "../pages/telemedicines/telemedicines";
import { PatientMessages } from "../pages/messages/messages";
import { Medications } from "../pages/medications/medications";
import { Immunizations } from "../pages/immunizations/immunizations";
import PatientSwitch from "../pages/PatientSwitch";
import { isPatient, isCaregiver, getUser, isAccessRoute } from "../userStore";
import Appointments from "../pages/Appointments";
import Settings from "../pages/settings/settings";
import CreatePin from "../pages/auth/CreatePin";
import { Vitals } from "../pages/vitals/vitals";
import { Educations } from "../pages/educations/educations";
import VisitSummaries from "../pages/visit_summaries/visitSummaries";
import Documents from "../pages/documents/documents";
import { FaUser } from "react-icons/fa";
import { IoHomeSharp } from "react-icons/io5";
import { FaListCheck } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa";
import { FaHandHoldingMedical } from "react-icons/fa";
import { GiLoveInjection } from "react-icons/gi";
import { MdAttachEmail } from "react-icons/md";
import { TbActivityHeartbeat } from "react-icons/tb";
import { FaSchool } from "react-icons/fa";
import { IoIosSettings } from "react-icons/io";
import { RiUserVoiceFill } from "react-icons/ri";
import { FaUserFriends } from "react-icons/fa";
import { PiStethoscopeBold } from "react-icons/pi";
import { MdHealthAndSafety } from "react-icons/md";
import { IoDocument } from "react-icons/io5";
import { FaFlask } from "react-icons/fa";
import { MdAccountTree } from "react-icons/md";
import { FaCalendarCheck } from "react-icons/fa";
import { RiUserSearchFill } from "react-icons/ri";
import { LuNewspaper } from "react-icons/lu";
import ProviderSearch from "../pages/ProviderSearch";
import Notifications from "../pages/notifications/notifications";
import { FaRegCreditCard } from "react-icons/fa";
import Billing from "../pages/Billing";
import ClinicalSummary from "../pages/clinical_summary/clinicalSummary";
import { FaBell } from "react-icons/fa";
import FHIR from "../pages/FHIR";
import { TbUserShield } from "react-icons/tb";
const patientNmae = getUser()?.patient ? getUser()?.patient : getUser()?.fname;

export const componentRoutes = [
  {
    path: "/patients",
    element: <PatientSwitch />,
    title: "Switch User  (" + patientNmae + ")",
    slug: "patients",
    nav: false,
  },
  {
    path: "/dashboard",
    element: <PatientDashboard />,
    title: "Dashboard",
    public: isPatient(),
    icon: IoHomeSharp,
    nonActiveClass: "bg-sky-600 text-white",
    slug: "dashboard",
  },
  {
    path: "/notifications",
    element: <Notifications />,
    title: `Notifications`,
    public: isAccessRoute("Notifications", "notifications_view "),
    accessSlug:'view',
    icon: FaBell,
    nonActiveClass: "bg-green-600 text-white",
    slug: "notifications",
  },
  {
    path: "/care-plan",
    element: <CarePlan />,
    title: "Care Plan",
    public: isAccessRoute("Care Plan", "care plan_view"),
    accessSlug:'view',
    icon: FaListCheck,
    nonActiveClass: "bg-yellow-500 text-white",
    slug: "care_plan",
  },
  {
    path: "/clinical-summary",
    element: <ClinicalSummary />,
    title: "Clinical Summary",
    public: isAccessRoute("Clinical Summary", "clinical summary_view"),
    accessSlug:'view',
    icon: LuNewspaper,
    nonActiveClass: "bg-green-500 text-white",
    slug: "clinical_summary",
  },
  {
    path: "/demographics",
    element: <PatientDemographics />,
    title: "Demographics",
    public: isAccessRoute("Demographics", "demographics_view"),
    accessSlug:'view',
    nonActiveClass: "bg-orange-600 text-white",
    icon: FaUser,
    slug: "demographics",
  },
  {
    slug: "fhir",
    path: "/fhir",
    element: <FHIR />,
    title: "FHIR",
    nonActiveClass: "text-black bg-blue-200",
    icon: TbUserShield,
  },
  {
    path: "/messages",
    element: <PatientMessages />,
    title: "Messages",
    public: isAccessRoute("Messages", "messages_view"),
    accessSlug:'view',
    nonActiveClass: "bg-sky-600 text-white",
    icon: FaEnvelope,
    slug: "messages",
  },
  {
    path: "/medications",
    element: <Medications />,
    title: "Medications",
    public: isAccessRoute("Medications", "medications_view"),
    accessSlug:'view',
    icon: FaHandHoldingMedical,
    nonActiveClass: "bg-pink-700 text-white",
    slug: "medications",
  },
  {
    path: "/immunization",
    element: <Immunizations />,
    title: "Immunizations",
    public: isAccessRoute("Immunizations", "immunizations_view"),
    accessSlug:'view',
    icon: GiLoveInjection,
    nonActiveClass: "bg-yellow-500 text-white",
    slug: "immunizations",
  },
  {
    path: "/patient-letters",
    element: <PatientLetters />,
    title: "Letters and Orders",
    public: isAccessRoute("Letters/Orders", "letters_orders_view"),
    accessSlug:'view',
    icon: MdAttachEmail,
    nonActiveClass: "bg-orange-900 text-white",
    slug: "letters_and_orders",
  },
  {
    path: "/education",
    element: <Educations />,
    title: "Education",
    public: isAccessRoute("Education", "education_view"),
    accessSlug:'view',
    icon: FaSchool,
    nonActiveClass: "bg-orange-600 text-white",
    slug: "education",
  },
  {
    path: "/vitals",
    element: <Vitals />,
    title: "Vitals",
    public: isAccessRoute("Vitals", "vitals_view"),
    accessSlug:'view',
    icon: TbActivityHeartbeat,
    nonActiveClass: "bg-purple-600 text-white",
    slug: "vitals",
  },
  {
    path: "/referrals",
    element: <Referrals />,
    title: "Referrals",
    public: isAccessRoute("Referrals", "referrals_view"),
    accessSlug:'view',
    icon: FaUserFriends,
    nonActiveClass: "bg-green-400 text-white",
    slug: "referrals",
  },
  {
    path: "/campaigns",
    element: <Campaigns />,
    title: "Campaigns",
    public: isAccessRoute("Campaigns", "campaigns_view"),
    accessSlug:'view',
    icon: RiUserVoiceFill,
    nonActiveClass: "bg-pink-800 text-white",
    slug: "campaign",
  },
  {
    path: "/telemedicines",
    element: <Telemedicines />,
    title: "Telemedicine",
    public: isPatient(),
    icon: PiStethoscopeBold,
    nonActiveClass: "bg-green-400 text-white",
    accessSlug:'view',
    slug: "telemedicine",
  },
  {
    path: "/visit-summaries",
    element: <VisitSummaries />,
    title: "Visit",
    public: isAccessRoute("Clinical Summary", "clinical summary_view"),
    accessSlug:'view',
    icon: MdHealthAndSafety,
    nonActiveClass: "bg-green-700 text-white p0",
    slug: "visits",
  },
  {
    path: "/documents",
    element: <Documents />,
    title: "Documents",
    public: isAccessRoute("Documents", "documents_view"),
    accessSlug:'view',
    icon: IoDocument,
    nonActiveClass: "bg-sky-300 text-white",
    slug: "documents",
  },
  {
    path: "/billing",
    element: <Billing />,
    title: "Billing View",
    public: isAccessRoute("Billing View", "billing_view"),
    accessSlug:'view',
    nonActiveClass: "bg-green-600 text-white",
    icon: FaRegCreditCard,
    slug: "billing_view",
  },
  {
    path: "/lab-results",
    element: <LabResults />,
    title: "Lab Results",
    public: isAccessRoute("Lab Results", "lab_results_view"),
    accessSlug:'view',
    icon: FaFlask,
    nonActiveClass: "bg-pink-600 text-white",
    slug: "lab_results",
  },
  {
    path: "/trackers",
    element: <Trackers />,
    title: "Trackers",
    public: isAccessRoute("Trackers", "trackers_view"),
    accessSlug:'view',
    icon: MdAccountTree,
    nonActiveClass: "bg-pink-600 text-white",
    slug: "trackers",
  },
  {
    path: "/appointments",
    element: <Appointments />,
    title: "Appointments",
    public: isAccessRoute("Appointments", "appointments_view"),
    accessSlug:'view',
    nonActiveClass: "bg-green-600 text-white",
    icon: FaCalendarCheck,
    slug: "appointments",
  },
  {
    path: "/create-pin",
    element: <CreatePin />,
    title: "Create Pin",
    public: true,
    nonActiveClass: "bg-sky-600 text-white",
    slug: "create_pin",
    nav: false,
  },
  {
    path: "/provider-search",
    element: <ProviderSearch />,
    title: "Provider Search",
    public: isAccessRoute("Provider Search", "provider search_view"),
    accessSlug:'view',
    slug: "provider_search",
    nonActiveClass: "bg-sky-500 text-white",
    icon: RiUserSearchFill,
  },
  {
    slug: "settings",
    path: "/settings",
    element: <Settings />,
    title: "Settings",
    nonActiveClass: "text-black bg-blue-200",
    icon: IoIosSettings,
  },
].filter(Boolean);
// clinical_summary, notifications, provider_search
